export enum SupportFeatureFlags {
    EnableOutpatientClinicTaskList = 'ENABLE_OUTPATIENT_CLINIC_TASK_LIST',
    EnableSupportExporter = 'ENABLE_SUPPORT_EXPORTER',
}
